import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Analytics from "helpers/analytics";
import Dropdown from "../../shared/Dropdown";
import CategoriesWrapper from "../styles/Categories.style";

const CATEGORIESLIST = [
  "Animals",
  "Art",
  "Awesome",
  "Cooking",
  "Crashes",
  "Cute",
  "DIY",
  "Fails",
  "Family",
  "Funny",
  "Heartwarming",
  "Lifestyle",
  "Nature",
  "Newsworthy",
  "Paranormal",
  "Parenting",
  "Pets",
  "Talent",
  "Travel",
  "Trending",
  "Vehicles",
  "Weather",
  "Wildlife",
  "Workout"
];

function CategoriesElastic(props) {
  const onSelectCategories = (item) => {
    Analytics.track("CategoriesDropdown", {
      category: "LP-TopNav",
      label: item === "Trending" ? "The Wire" : item
    });

    if (item !== "Trending") {
      let params = props.search.searchParams;
      params.sort = "_score";
      params.page = 1;
      params.q = item;
      props.getSearchResults(params);
    }
  };

  return (
    <CategoriesWrapper className="categories">
      <Dropdown
        buttonClass="filter--toggle"
        autoClose
        text={
          <>
            Categories <ArrowDropDownIcon />
          </>
        }
      >
        <div className="categories-container">
          {CATEGORIESLIST.map((item, index) =>
            item === "Trending" ? (
              <Link id={`${item.toLocaleLowerCase()}-link`} key={index} to={`/licensing/thewire`} onClick={() => onSelectCategories(item)}>
                <Button>Trending</Button>
              </Link>
            ) : (
              <Link
                key={index}
                id={`${item.toLocaleLowerCase()}-link`}
                to={`/licensing/search?q=${item.toLocaleLowerCase()}`}
                onClick={() => onSelectCategories(item)}
              >
                <Button>{item}</Button>
              </Link>
            )
          )}
        </div>
      </Dropdown>
    </CategoriesWrapper>
  );
}

export default CategoriesElastic;
